/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IncodeInputs */



/**
* | output |
* | --- |
* | "Incode" |
*
* @param {IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const incode = /** @type {((inputs?: IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Incode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incodificare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроенный код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incodificar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Incode")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोड में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incode")
	return /** @type {LocalizedString} */ ("Incode")
});